import React from "react";
import { WHATSAPP_URL } from "@/lib/constants";
import { useScrolled } from "@/hooks/useScrolled";

/* -------------------------------------------------------------------------- */
/*  Sub-components                                                            */
/* -------------------------------------------------------------------------- */

const Logo = ({ scrolled }) => (
    <a
        href="#top"
        data-testid="logo-link"
        aria-label="Oliva Implantes — Excelência em Reabilitação Oral e Implantes Dentários — São Bernardo do Campo, SP"
        className="group flex min-w-0 flex-col leading-none"
    >
        <span
            className={`font-serif text-[15px] uppercase tracking-widestx transition-colors duration-500 sm:text-[17px] md:text-[19px] ${
                scrolled ? "text-onyx" : "text-white"
            }`}
        >
            Oliva Implantes
        </span>
        <span
            className={`mt-1 hidden font-sans text-[10px] font-light leading-tight tracking-[0.14em] transition-colors duration-500 md:block md:text-[11px] ${
                scrolled ? "text-onyx/60" : "text-white/70"
            }`}
        >
            Excelência em Reabilitação Oral e Implantes Dentários
        </span>
        <span
            className={`mt-1 hidden font-serif text-[10px] italic leading-tight tracking-wide transition-colors duration-500 md:block md:text-[11px] ${
                scrolled ? "text-gold-600/85" : "text-gold-300/90"
            }`}
        >
            Implantes dentários em São Bernardo do Campo, SP
        </span>
    </a>
);

const HeaderCta = () => (
    <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="header-cta"
        className="group relative inline-flex flex-none items-center justify-center overflow-hidden border border-gold-500 bg-gold-500 px-4 py-3 font-sans text-[10px] font-semibold uppercase tracking-widestx text-white transition-all duration-500 hover:bg-gold-600 hover:border-gold-600 md:px-7 md:py-3.5 md:text-xs"
    >
        <span className="relative z-10 whitespace-nowrap">
            Agendar Avaliação
        </span>
        <span className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
    </a>
);

/* -------------------------------------------------------------------------- */
/*  Header                                                                    */
/* -------------------------------------------------------------------------- */

const Header = () => {
    const scrolled = useScrolled(24);

    return (
        <header
            data-testid="site-header"
            className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-ivory/95 backdrop-blur-md shadow-[0_1px_0_0_rgba(10,25,47,0.06)]"
                    : "bg-transparent"
            }`}
        >
            <div className="container-luxe flex h-20 items-center justify-between gap-4 md:h-24">
                <Logo scrolled={scrolled} />
                <HeaderCta />
            </div>
        </header>
    );
};

export default Header;
